import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "filter",
  "use": "filter-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"filter\"><path d=\"M16 4.17a3.001 3.001 0 0 1 0 5.66V18h-2V9.83a3.001 3.001 0 0 1 0-5.66V0h2zm-6 6a3.001 3.001 0 0 1 0 5.66V18H8v-2.17a3.001 3.001 0 0 1 0-5.66V0h2zm-6-8a3.001 3.001 0 0 1 0 5.66V18H2V7.83a3.001 3.001 0 0 1 0-5.66V0h2zM3 6.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm6 8a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm6-6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol